import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface EmailTemplatesState {
  modalLoading: boolean;
  toastMessage: {
    new: boolean;
    success: string;
    errors: string[];
  };
}

const initialState: EmailTemplatesState = {
  modalLoading: false,
  toastMessage: {
    new: false,
    success: "",
    errors: [],
  },
};

const emailTemplateSlice = createSlice({
  name: "emailTemplates",
  initialState,
  reducers: {
    setEmailTemplateLoading: (state) => {
      state.modalLoading = true;
    },
    createEmailTemplateSuccess: (state) => {
      state.modalLoading = false;
      state.toastMessage = {
        success: "Email template created successfully!",
        errors: [],
        new: true,
      };
    },
    createEmailTemplateFail: (state, action: PayloadAction<string[]>) => {
      state.modalLoading = false;
      state.toastMessage = {
        success: "",
        errors: action.payload,
        new: true,
      };
    },
    editEmailTemplateSuccess: (state) => {
      state.modalLoading = false;
      state.toastMessage = {
        success: "Email template updated successfully!",
        errors: [],
        new: true,
      };
    },
    editEmailTemplateFail: (state, action: PayloadAction<string[]>) => {
      state.modalLoading = false;
      state.toastMessage = {
        success: "",
        errors: action.payload,
        new: true,
      };
    },
    deleteEmailTemplateSuccess: (state) => {
      state.toastMessage = {
        success: "Email template deleted successfully!",
        errors: [],
        new: true,
      };
    },
    deleteEmailTemplateFail: (state, action: PayloadAction<string[]>) => {
      state.toastMessage = {
        success: "",
        errors: action.payload,
        new: true,
      };
    },
    resetEmailTemplateStore(state) {
      state.modalLoading = false;
      state.toastMessage = {
        new: false,
        success: "",
        errors: [],
      };
    },
  },
});

export const {
  setEmailTemplateLoading,
  createEmailTemplateSuccess,
  createEmailTemplateFail,
  editEmailTemplateSuccess,
  editEmailTemplateFail,
  deleteEmailTemplateSuccess,
  deleteEmailTemplateFail,
  resetEmailTemplateStore,
} = emailTemplateSlice.actions;

export default emailTemplateSlice.reducer;
